import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import type { ModalProps } from "antd/lib/modal";
import { ModalWrapper } from "../ModalWrapper";
import { getAddTagModalSchema, type AddTagModalFormValues } from "./schema";
import { Form } from "./Form";
import { FormFields } from "./FormFields";

interface Props extends ModalProps {
  onSubmit: (value: AddTagModalFormValues) => void;
  onClick: () => void;
}

export const ModalAddTag: React.FC<Props> = ({ onSubmit, ...props }) => {
  const formApi = useForm({
    defaultValues: { tag: "" },
    resolver: yupResolver(getAddTagModalSchema()),
  });

  useEffect(() => {
    if (props.open) {
      const timer = setTimeout(() => {
        formApi.setFocus("tag");
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [props.open]);

  const submitHandler = (data: AddTagModalFormValues) => {
    onSubmit(data);
    formApi.reset();
  };

  const disabled = !formApi.formState.isValid;

  return (
    <ModalWrapper
      type="save"
      modalTitle="New tag"
      modalRender={(node) => (
        <Form formApi={formApi} onSubmit={submitHandler}>
          {node}
        </Form>
      )}
      okButtonProps={{ htmlType: "submit", disabled }}
      {...props}
    >
      <FormFields />
    </ModalWrapper>
  );
};
